export const DANCE_FORMS = ["Salsa", "Bachata", "Kizomba", "Zouk", "Merengue"];
export const DANCE_LEVELS = ["Beginner", "Improver", "Intermediate", "Advanced"];
export const DANCE_ROLES = ["Leader", "Follower", "Both"];
export const ROLE_COLORS = { Leader: "leaders", Follower: "followers", Both: "pink" };
export const ROLE_LABELS = { Leader: "Leader (masc)", Follower: "Follower (femme)", Both: "Both" };
